import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./components/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'statements',
    loadComponent: () =>
      import('./components/statement-list/statement-list.component').then(
        (m) => m.StatementListComponent,
      ),
  },
  {
    path: 'editar-registros',
    loadComponent: () =>
      import('./components/editar-registros/editar-registros.component').then(
        (m) => m.EditarRegistrosComponent,
      ),
  },
  {
    path: 'editar-empresas',
    loadComponent: () =>
      import('./components/editar-empresas/editar-empresas.component').then(
        (m) => m.EditarEmpresasComponent,
      ),
  },
  {
    path: 'vista-taxonomia',
    loadComponent: () =>
      import('./components/vista-por-taxonomia/vista-por-taxonomia.component').then(
        (m) => m.VistaPorTaxonomiaComponent,
      ),
  },
  {
    path: 'carga-masiva',
    loadComponent: () =>
      import('./components/carga-masiva/carga-masiva.component').then(
        (m) => m.CargaMasivaComponent,
      ),
  },
  { path: '**', redirectTo: '/dashboard' },
];
